<template>
  <div class="upload">
    <div class="imgOver fL marR20" v-for="(item,key) in fileList" :key="key">
      <a class="zoom zoom-in" @click="handleFileEnlarge(item.url)">
        <div v-if="!item.url.toLocaleLowerCase().endsWith('.pdf')" class="imgupload" :style="{backgroundImage: 'url(' + item.url + ')' }"></div>
        <div v-else class="imguploadPdf"></div>
      </a>
      <i class="el-icon-error dele " v-if="!inputCard.options.disabled && item.status != 2 " @click="handleFileRemove(item,key) "/>
      <div class="mask " v-if="!inputCard.options.disabled  && item.status != 2">
        <div class="again fontW " @click="handleFileRest(item,key) ">重新上传</div>
      </div>
    </div>
    <div v-if="!pass && progress !==0 " class="imgOver fL marR20 ">
      <div class="imgupload" :style="{backgroundImage: 'url(' + localfole.url + ')' }">
        <!--<img width="730 " height="530 " :src="dialogImageUrl " alt=" ">-->
      </div>
      <!--<img :src="localfole.url " :alt="localfole.name ">-->
      <div class="maskBg " :style=" 'height: '+progress+ '%;' "></div>
      <div class="num ">{{ progress }}%</div>
    </div>
    <el-upload v-if="!inputCard.options.disabled" :file-list="fileList" class="avatar-uploader fL marR20 " multiple :limit="9" style="padding-top: 0px; margin-bottom:-10px; " drag :ref="inputKey " :show-file-list="false " :before-upload="beforeUpload " :name="inputKey " :on-error="uploadOnError" :on-exceed="uploadExceed" :on-progress="uploadOnProgress " v-bind="options" :on-success="uploadOnSuccess " :on-preview="onPreview " :on-remove="onRemove ">
      <i class="el-icon-circle-plus-outline add_size"/>
      <em>点击或拖拽上传</em>
      <p>JPG/PNG/GIF/PDF文件尺寸不限，大小不超过10M</p>
    </el-upload>
    <z-layer :ref="inputKey+ '_layer' " :visible.sync="dialogVisible">
      <div class="imgbigover" :style="{backgroundImage: 'url(' + dialogImageUrl + ')' }">
        <!--<img width="730 " height="530 " :src="dialogImageUrl " alt=" ">-->
      </div>
    </z-layer>
  </div>
</template>
<script>
/* eslint-disable */
import Layer from "@/components/dialoglayer/Layer";
import { getData } from "@/utils/utils";
import qs from 'qs';
export default {
  name: "upload-list",
  components: {
    "z-layer": Layer
  },
  props: {
    inputKey: String,
    onError: {
      type: Function,
      default: () => {}
    },
    onProgress: {
      type: Function,
      default: () => {}
    },
    inputCard: Object,
    onSuccess: {
      type: Function,
      default: () => {}
    },
    onPreview: {
      type: Function,
      default: () => {}
    },
    onRemove: {
      type: Function,
      default: () => {}
    },
    fileList: Array
  },
  watch: {
    fileList: function(newVal, oldVal) {}
  },
  data: function() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      progress: 0, // 上传进度
      pass: null, // 是否上传成功
      localfole: {
        name: "",
        url: ""
      },
      options: {},
      loadIntrval: {},
      uploadEnable: true,
      uploadData:{},
      currentFileIndex:1,
    };
  },
  created: function() {
    if (this.$route.query['loginParam']) {
      this.uploadData = {loginParam:this.$route.query['loginParam']}
    }
    for (let key in this.inputCard.options) {
      if (this.inputCard.options[key] === 0) {
        this.inputCard.options[key] = false;
      }
      if (this.inputCard.options[key] === 1) {
        this.inputCard.options[key] = true;
      }
    }
    this.options = this.inputCard.options;
    if (this.$route.query["customer_id"]) {
      this.options["data"]["customer_id"] = this.$route.query["customer_id"];
    }
    if (this.$route.query["clientId"]) {
      this.options["data"]["clientId"] = this.$route.query["clientId"];
    }
  },
  computed: {
    proStatus: function() {
      // 上传状态
      if (this.pass) {
        return "success";
      } else if (this.pass === false) {
        return "exception";
      } else {
        return "";
      }
    }
  },
  methods: {
    uploadOnProgress: function(event, file, fileList) {
      if(this.currentFileIndex == 1) {
        clearInterval(this.loadIntrval);
        this.uploadEnable = false;
        this.pass = false
        let loading = event.percent.toFixed(0);
        this.progress = (loading / 5).toFixed(0);
        if (loading == 100) {
          this.loadIntrval = setInterval(() => {
            if (this.progress != 100) {
              this.progress++;
            }
          }, 10);
        }
        this.localfole = {
          name: file.name,
          url: file.url
        };
      }else{
        this.currentFileIndex ++ 
      }
    },
    // uploadOnChange: function(file) {
    //   if (file.status === "ready") {
    //     this.pass = null;
    //     this.progress = 0;
    //     clearInterval(this.loadIntrval);
    //   } else if (file.status === "fail") {
    //     this.$message.error("图片上传出错，请刷新重试！");
    //   }
    // },
    beforeUpload: function(file) {
      if (!this.uploadEnable) {
        this.$message.warning("请等待上一次文件上传完成");
        return false;
      }
      // this.pass = false;
      // this.progress = 0;
      // clearInterval(this.loadIntrval);
      if (file.size / 1024 / 1024 > 10) {
        this.$message.warning("上传文件大小不能超过10M");
        return false;
      }
    },
    uploadOnSuccess: function(e, file, fileList) {
      if(fileList.some(item => item.status == "uploading")){
        return;
      }
      clearInterval(this.loadIntrval);
      this.uploadEnable = true;
      this.progress = 100;
      this.pass = true;
      fileList.forEach(item => {
        if(item.response){
          if(item.response.code == 0){
            this.fileList.push({
              url: item.response.data.httpurl,
              name: item.response.data.filename
            });
          }else {
            this.$message.warning(item.name + "上传错误");
          }
        }
      })
      this.$emit("validate-upload", this.inputKey);
      this.progress = 0;
      this.currentFileIndex = 1;
    },
    uploadOnError: function(err, file, fileList) {
      if(fileList.length == 1){
        clearInterval(this.loadIntrval);
        this.uploadEnable = true;
        this.pass = true;
        this.progress = 0;
        let msg = "上传文件错误";
        try {
          let msg = JSON.parse(err.message).msg || "上传文件错误";
        } catch (e) {}
        this.$message.warning(msg);
    }
    },
    handleFileEnlarge: function(_url) {
      // 放大图片
      if (_url && !_url.toLocaleLowerCase().endsWith(".pdf")) {
        this.dialogImageUrl = _url;
        this.dialogVisible = true;
      }
      // 打开pdf
      if (_url && _url.toLocaleLowerCase().endsWith(".pdf")) {
        let data = qs.parse(_url.split("?")[1]);
        if(data && data.Expires){
          if(new Date().getTime() > String(data.Expires).padEnd(13,'0')){
            getData("/api/file/ssig/update", { url: _url }, res => {
                if (res.code == 0) {
                  window.open(res.data,'_blank')
                } else {
                  window.location.reload()
                }
            },error => window.location.reload());
          }else {
            window.open(_url,'_blank')
          }
        }else {
          window.open(_url,'_blank')
        }
      }
    },
    handleFileRemove: function(file, i) {
      // 删除图片
      if (!file.url) {
        return false;
      }
      this.fileList.splice(i, 1);
    },
    handleFileRest: function(item, key) {
      this.handleFileRemove(item, key);
    },
    uploadExceed: function(files, fileList) {
      this.$message.warning("上传文件不能超过" + fileList.length + "个");
    },
    formatterHttps: function(value) {
      return "//sinastorage.cn" + value.split(':/')[1] || value;
    }
  }
};
</script>
<style>
.upload .uploader-padding {
  margin-top: 20px;
}

.upload .el-upload--picture-card {
  width: 280px;
  height: 210px;
  border: none;
  line-height: 20px;
}

.imgOver {
  width: 280px;
  height: 210px;
  background-color: #f9fafd;
  border: 1px solid #e1e6f1;
  position: relative;
  overflow: hidden;
  margin-top: 0px;
}

.imgupload {
  width: 280px;
  height: 210px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  background-color: #f9fafd;
}
.imguploadPdf {
  width: 280px;
  height: 210px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 50%;
  background-color: #f9fafd;
  background-image: url('../../assets/PDF.png');
}

.imgbigover {
  width: 750px;
  max-height: 530px;
  overflow: hidden;
  margin: 0;
  padding-bottom: 90%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.upload .imgOver .dele {
  background: #fff;
  position: absolute;
  color: rgba(0, 0, 0, 0.3);
  right: 10px;
  top: -20px;
  width: 14px;
  height: 14px;
  text-align: center;
  line-height: 14px;
  border-radius: 50%;
  transition: all 0.3s ease 0s;
}

.upload .imgOver:hover .dele {
  top: 10px;
}

.upload .el-upload-dragger:hover {
  background: #f9fafd;
}

.upload .el-upload-dragger:hover .add_size {
  color: #2a60e4;
}

.fontW {
  color: #fff;
  font-size: 14px;
  font-family: "PingFangSC-Medium", "Microsoft YaHei", "微软雅黑", Arial,
    sans-serif;
}

.again.fontW:hover {
  color: #2a60e4;
  /*cursor: default;*/
}

.add_size{
  font-size: 40px;
  color: #bbc0d5;
  padding: 66px 0 20px;
  line-height: 0;
}

.upload .imgOver .num {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
}

.upload .imgOver .maskBg {
  width: 100%;
  height: 0;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  left: 0;
  bottom: 0;
  text-align: center;
  cursor: pointer;
}

.upload .imgOver .mask {
  width: 100%;
  height: 0;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  left: 0;
  bottom: 0;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease 0s;
}

.upload .imgOver:hover .mask {
  height: 20%;
}

.upload p {
  font-size: 12px;
  color: #c4c9da;
  line-height: 20px;
  padding-top: 3px;
  font-family: "PingFangSC-Regular", "Hiragino Sans GB", "Microsoft YaHei",
    "微软雅黑", Arial, sans-serif;
}

.upload .el-upload--picture-card i {
  font-size: 40px;
}

.upload em {
  font-style: normal;
  color: #07175d;
  display: block;
  line-height: 20px;
  padding-top: 12px;
  font-size: 14px;
  font-family: "PingFangSC-Regular", "Hiragino Sans GB", "Microsoft YaHei",
    "微软雅黑", Arial, sans-serif;
}

.upload .el-upload-dragger {
  width: 280px;
  height: 210px;
}

.upload .el-upload-dragger .el-upload__text {
  color: #07175d;
}

.upload .el-upload-dragger {
  border: 1px solid #e1e6f1;
  background: #f9fafd;
  border-radius: 0;
}

.is-success .imgOver {
  border: 1px solid #67c23a;
}

.zoom {
  display: inline-block;
}

.zoom-in {
  cursor: zoom-in;
}

.zoom-out {
  cursor: zoom-out;
}
</style>



// WEBPACK FOOTER //
// src/components/form/Upload.vue